import { useUploadLogoPage } from "./logic";
import { UploadLogoTemplate } from "./template";

export const UploadLogoPage = (): JSX.Element => {
  const props = useUploadLogoPage();
  return <UploadLogoTemplate {...props} />;
}; 